
/**
 * 降順取得
 */
export const listUserByUpdatedAt = /* GraphQL */ `
  query ListUserByUpdatedAt(
    $owner: String
    $updatedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserByUpdatedAt(
      owner: $owner
      updatedAt: $updatedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        licenceLimit {
          nextToken
        }
        licence {
          nextToken
          items {
            active
            id
            owner
            type
            userId
          }
        }
        username
        mailaddress
        companyName
        corp
        active
        updatedAt
        createdAt
      }
      nextToken
    }
  }
`;

export const listLicences = /* GraphQL */ `
  query ListLicences(
    $id: ID
    $filter: ModelLicenceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLicences(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        userId
        licenceBind {
          nextToken
        }
        type
        period
        subscriptionExpiryDateAt
        maintenancePeriod
        acsVersionId
        acsVersion {
          id
          no
          version
          releaseDate
          active
          updatedAt
          createdAt
        }
        licenceKey
        uuid
        active
        updatedAt
        createdAt
        owner
      }
      nextToken
    }
  }
`;